import { PROFILE_BACKUP_KEY, PROFILE_KEY, PROFILE_QUARANTINE_KEY } from './types';

/** The unlock build keeps a separate glen so a test save cannot touch the real one. */
export function unlockBuild(): boolean {
  return import.meta.env?.VITE_UNLOCK_ALL === '1';
}

export function profileKeys(unlock = unlockBuild()): {
  profile: string;
  backup: string;
  quarantine: string;
} {
  if (!unlock) {
    return { profile: PROFILE_KEY, backup: PROFILE_BACKUP_KEY, quarantine: PROFILE_QUARANTINE_KEY };
  }
  return {
    profile: 'critter-clatter.profile.unlock',
    backup: 'critter-clatter.profile.unlock.bak',
    quarantine: 'critter-clatter.profile.unlock.quarantine',
  };
}
